import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Html5QrcodeScanner } from "html5-qrcode";
import { qr } from "../services/api";
import {
  BackIcon,
  CameraIcon,
  HomeIcon,
  PlusIcon,
  UserIcon,
  InfoIcon,
} from "../components/Icons";

function Scanner() {
  const navigate = useNavigate();
  const [scanning, setScanning] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const scanner = new Html5QrcodeScanner("qr-reader", {
      fps: 10,
      qrbox: { width: 250, height: 250 },
      aspectRatio: 1.0,
    });

    const onScanSuccess = async (decodedText) => {
      setScanning(false);
      scanner.clear();

      try {
        // Extract QR code from URL if it's a full URL
        let qrCode = decodedText;
        if (decodedText.includes("/scan/")) {
          qrCode = decodedText.split("/scan/").pop();
        }

        // /qr/resolve answers { type: "entity", entity } or
        // { type: "unassigned", qr_code }. There is no top-level id — reading
        // one sent every scan to /entity/undefined.
        const { data } = await qr.resolve(qrCode);

        if (data?.type === "entity" && data.entity?.id) {
          navigate(`/entity/${data.entity.id}`);
        } else {
          // Unknown or unassigned code: hand off to the scan route, which
          // offers to create an entity for it.
          navigate(`/scan/${encodeURIComponent(qrCode)}`);
        }
      } catch (err) {
        setError("Couldn't look up that code. Try again.");
        setTimeout(() => {
          setError(null);
          setScanning(true);
          scanner.render(onScanSuccess, () => {});
        }, 2000);
      }
    };

    scanner.render(onScanSuccess, () => {});

    return () => {
      scanner.clear().catch(() => {});
    };
  }, [navigate]);

  return (
    <div style={{ minHeight: "100vh", paddingBottom: "80px" }}>
      {/* Header */}
      <div className="header">
        <div className="header-content">
          <button
            onClick={() => navigate("/")}
            className="btn btn-ghost btn-icon"
          >
            <BackIcon size={20} />
          </button>
          <div className="header-text">
            <h1 className="header-title">Scan QR Code</h1>
            <p className="header-subtitle">Point your camera at a QR code</p>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="card">
          {error && (
            <div
              style={{
                padding: "var(--spacing-md)",
                background: "rgba(239, 68, 68, 0.1)",
                border: "1px solid var(--accent-danger)",
                borderRadius: "var(--radius-md)",
                color: "var(--accent-danger)",
                textAlign: "center",
                marginBottom: "var(--spacing-lg)",
              }}
            >
              {error}
            </div>
          )}

          <div
            id="qr-reader"
            style={{ borderRadius: "var(--radius-md)", overflow: "hidden" }}
          ></div>

          <div
            style={{
              marginTop: "var(--spacing-lg)",
              padding: "var(--spacing-md)",
              background: "var(--bg-secondary)",
              borderRadius: "var(--radius-md)",
              fontSize: "0.875rem",
              color: "var(--text-secondary)",
              borderLeft: "3px solid var(--accent-primary)",
              display: "flex",
              alignItems: "flex-start",
              gap: "var(--spacing-sm)",
            }}
          >
            <InfoIcon size={16} style={{ flexShrink: 0, marginTop: "2px" }} />
            <span>
              <strong>Tip:</strong> Make sure the QR code is well-lit and
              centered in the camera view.
            </span>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="quick-actions">
          <div className="quick-action" onClick={() => navigate("/")}>
            <div className="quick-action-icon">
              <HomeIcon size={24} />
            </div>
            <div className="quick-action-label">Home</div>
          </div>
          <div className="quick-action" onClick={() => navigate("/create")}>
            <div className="quick-action-icon">
              <PlusIcon size={24} />
            </div>
            <div className="quick-action-label">Add Item</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Scanner;
